export default __webpack_public_path__ + "images/pie-chart-dummy-140.c692672ed2d243c82d97f62196b89365.svg";